module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.library.js
 ** module id = 42
 ** module chunks = 73
 **/